<div>
    <button mat-icon-button class="close-button" (click)="snackBarRef.dismiss()">
        <mat-icon class="close-icon" color="black">close</mat-icon>
    </button>
    <div>
        <h2><b>{{data.type}}</b></h2>
    </div>
    <div>
        <b>{{data.message}}</b>
    </div>
</div>